class PianoBuildError extends Error {}
module.exports = PianoBuildError;